import React from "react";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Tutorial from "./components/Tutorial";
import "./App.css";
import "./i18n";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NotFound from "./components/NotFound";
import Categories from "./components/Categories";
import SongDetail from "./components/SongDetail";
import Songs from "./components/Songs";
import Sidebar from "./components/Sidebar";
import PlankPage from "./components/PlankPage";
import Admin from "./components/Admin";
import AdminDashboard from "./components/AdminDashboard";
import EditSong from "./components/EditSong";
import Events from "./components/events";
import AdminSettings from "./components/Dashboard/AdminSettings";
import AdminSongs from "./components/Dashboard/AdminSongs";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import Header from "./components/Header";
import ImportHistory from "./components/ImportHistory.jsx";
import YouTubeStreams from "./components/YouTubeStreams";
import ConferencesContent from "./components/ConferencesContent";
import Overview from "./components/Overview";
import Support from "./components/Support";
// import Footer from "./components/Footer";
import { AllReports, AllSongs } from "./components/Dashboard/ui";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <div className="z-10 font-sans text-gray-800 bg-transparent flex-1 relative">
          <Sidebar />
          <Header />
          <main className="h-full ms-0 min-[1400px]:ms-[288px] transition-all duration-300">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/aboutUs" element={<AboutUs />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/songs" element={<Songs />} />
              <Route path="/songs/:id" element={<SongDetail />} />
              <Route path="/PlankPage" element={<PlankPage />} />
              <Route path="/Tutorial" element={<Tutorial />} />
              <Route path="/conferences" element={<ConferencesContent />} />
              <Route path="/support" element={<Support />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin-overview" element={<DashboardLayout />} />
              <Route path="/admin/songs" element={<AdminSongs />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/edit-song/:songID" element={<EditSong />} />
              <Route path="/old-admin" element={<AdminDashboard />} />
              <Route path="/Events" element={<Events />} />
              <Route path="/import-history" element={<ImportHistory />} />
              <Route path="/live-worship" element={<YouTubeStreams />} />
              <Route path="/all-reports" element={<AllReports />} />
              <Route path="/all-songs" element={<AllSongs />} />
            </Routes>
          </main>
        </div>
        <div className="ms-0 min-[1400px]:ms-[288px] transition-all duration-300">
          {/* Footer removed */}
        </div>
      </div>
    </Router>
  );
}

export default App;